import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { routerShape } from '@bibliocommons/bc-prop-types';
import { withRouter } from '@bibliocommons/utils-routing';

import useSearchScopes from 'app/hooks/useSearchScopes';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectCatalogSearch } from 'app/selectors/SearchSelector';
import EmptySearchResult from './EmptySearchResult';

const EmptySearchResultsContainer = ({ renderHeading, renderMobileSearchBox, router }) => {
  const intl = useIntl();

  const { currentScope, rootScope } = useSearchScopes();

  const alternativeScope = currentScope?.scopeId !== rootScope?.scopeId ? rootScope : null;

  const catalogSearch = useSelector(selectCatalogSearch);
  const library = useSelector(selectCurrentLibrary);

  const activeFilters = catalogSearch.get('activeFilters');
  const didYouMeanQuerySuggestion = catalogSearch.get('didYouMeanQuerySuggestion');
  const didYouMeanResultCount = catalogSearch.get('didYouMeanResultCount');
  const locked = catalogSearch.get('locked');
  const query = catalogSearch.get('query', '');
  const searchType = catalogSearch.get('searchType');
  const shelfName = catalogSearch.get('shelfName');

  let staticEmptySearchHtml = '';
  if (Object.hasOwn(intl.messages, 'static_empty_search_results_page')) {
    staticEmptySearchHtml = intl
      .formatMessage({
        id: 'static_empty_search_results_page'
      })
      .replace(/{query}/gi, query);
  }

  return (
    <EmptySearchResult
      activeFilters={activeFilters}
      alternativeScope={alternativeScope}
      currentScope={currentScope}
      didYouMeanQuerySuggestion={didYouMeanQuerySuggestion}
      didYouMeanResultCount={didYouMeanResultCount}
      intl={intl}
      library={library}
      locked={locked}
      query={query}
      renderHeading={renderHeading}
      renderMobileSearchBox={renderMobileSearchBox}
      router={router}
      searchType={searchType}
      shelfName={shelfName}
      staticEmptySearchHtml={staticEmptySearchHtml}
    />
  );
};

EmptySearchResultsContainer.propTypes = {
  renderHeading: PropTypes.func.isRequired,
  renderMobileSearchBox: PropTypes.func.isRequired,
  router: routerShape.isRequired
};

export default withRouter(EmptySearchResultsContainer);
